import { IonCol, IonContent, IonGrid, IonPage, IonButton, IonRow, IonText, useIonViewWillEnter, useIonViewWillLeave } from "@ionic/react";
import { useState } from "react";
import Footer from "../../components/Footer";
import { User } from '../../models/data';
import { translation } from "../../models/translation";
import { fetchUserDonations, fetchUserCredits } from '../../services/donate_service';
import { d_m_y, dd_mm_yyyy } from "../../utlities/ymd";
import './History.scss';

interface DocumentProps {
    user: User
}

const Profile: React.FC<DocumentProps> = (props) => {

    useIonViewWillEnter(() => {
        fetchDonationsData();
        fetchCreditsData();
    })


    const siteText = translation();

    const [donations, setDonations] = useState<any>(null);
    const [credits, setCredits] = useState<any>(null);
    const [view, setView] = useState<any>(0);
    const [loadingDonations, setLoadingDonations] = useState(false)
    const [loadingCredits, setLoadingCredits] = useState(false)

    useIonViewWillLeave(() => {
        setView(0)
    })

    const fetchDonationsData = async () => {
        let data = await fetchUserDonations(props.user.id);
        if (!data.error) {
            setDonations(data.message);
        } else {
            setDonations(data.error)
        }
        setLoadingDonations(true)
    }
    const fetchCreditsData = async () => {
        let data = await fetchUserCredits(props.user.id);
        if (!data.error) {
            console.log(data)
            setCredits(data.message);
        } else {
            setCredits(data.error)
        }
        setLoadingCredits(true)

    }

    const DonationsList = () => {
        return (
            donations.map((d: any, key: any) => {

                let date = d_m_y(d.acf.date);
                return (
                    <IonRow key={key} className="documentInfo  ion-margin-bottom">
                        <IonCol sizeXs="6" className="documentInfoHeader ion-hide-sm-up">
                            <IonText>{dd_mm_yyyy(date)}</IonText>
                        </IonCol>
                        <IonCol sizeXs="6" className="documentInfoHeader ion-hide-sm-up">
                            <IonText>{d.acf.status}</IonText>
                        </IonCol>
                        <IonCol sizeXs="12" sizeSm="2" className="ion-hide-sm-down">
                            <IonText>{dd_mm_yyyy(date)}</IonText>
                        </IonCol>
                        <IonCol sizeXs="5" sizeSm="2">
                            <IonText dangerouslySetInnerHTML={{ __html: d.acf.beneficiary }}></IonText>
                        </IonCol>
                        <IonCol sizeXs="3" sizeSm="2">
                            <IonText>{`${d.acf.tip?(d.acf.amount-d.acf.tip):d.acf.amount} CHF`}</IonText>
                        </IonCol>
                        <IonCol sizeXs="3" sizeSm="2">
                            <IonText>{`${(!d.acf.tip || d.acf.tip===0)?0.00:d.acf.tip} CHF`}</IonText>
                        </IonCol>
                        <IonCol sizeXs="4" sizeSm="2">
                            <IonText>{`${d.acf.donation_method}`}</IonText>
                        </IonCol>
                        <IonCol sizeXs="4" sizeSm="2" className="ion-hide-sm-down">
                            <IonText>{d.acf.status}</IonText>
                        </IonCol>
                    </IonRow>
                )
            }

            )

        )
    }
    const CreditList = () => {
        return (
            credits.map((d: any, key: any) => {

                let date = new Date(d.date);
                return (
                    <IonRow key={key} className="documentInfo  ion-margin-bottom">
                        <IonCol sizeXs="6" sizeSm="3" className=" documentInfoHeader ion-hide-sm-up">
                            <IonText>{`${dd_mm_yyyy(date)}`}</IonText>
                        </IonCol>
                        <IonCol sizeXs="6" sizeSm="3" className="documentInfoHeader ion-hide-sm-up" >
                            <IonText>{d.acf.status}</IonText>
                        </IonCol>
                        <IonCol sizeXs="2" sizeSm="3" className="ion-hide-sm-down">
                            <IonText>{`${dd_mm_yyyy(date)}`}</IonText>
                        </IonCol>
                        <IonCol sizeXs="6" sizeSm="2">
                            <IonText>{`${d.acf.amount} CHF`}</IonText>
                        </IonCol>
                        <IonCol sizeXs="6" sizeSm="4">
                            <IonText>{`${d.acf.credit_method}`}</IonText>
                        </IonCol>
                        <IonCol sizeXs="4" sizeSm="3" className="ion-hide-sm-down">
                            <IonText>{d.acf.status}</IonText>
                        </IonCol>
                    </IonRow>
                )
            }

            )

        )
    }

    return (
        <IonPage className="pageContent">
            <IonContent>
                <IonGrid className="innerBody accountSectionSpacingBottom">
                    <IonRow>
                        <IonCol>
                            <IonText>
                                <h1>{siteText.historyTitle}</h1>
                            </IonText>
                        </IonCol>
                        <IonCol size="12" className="historyViewSwitcher">
                            <IonButton color="dark" onClick={_ => setView(0)} className={view === 0 ? "active" : ""} fill="clear">Donations</IonButton>
                            <IonButton color="dark" onClick={_ => setView(1)} className={view === 1 ? "active" : ""} fill="clear">Credit</IonButton>
                        </IonCol>
                    </IonRow>
                    {view === 0 &&
                        <>
                            <IonRow className="documentInfoHeader ion-padding-start ion-padding-end ion-hide-sm-down" >
                                <IonCol sizeSm="2">
                                    <IonText>{siteText.historyDateTitle}</IonText>
                                </IonCol>
                                <IonCol sizeSm="2">
                                    <IonText>{siteText.historyBeneficiaryTitle}</IonText>
                                </IonCol>
                                <IonCol sizeSm="2">
                                    <IonText>{siteText.historyAmountTitle}</IonText>
                                </IonCol>
                                <IonCol sizeSm="2">
                                    <IonText>{siteText.historyTipTitle}</IonText>
                                </IonCol>
                                <IonCol sizeSm="2">
                                    <IonText>{siteText.historyTransactionMethodTitle}</IonText>{/* */}
                                </IonCol>
                                <IonCol sizeSm="2">
                                    <IonText>{siteText.historyStatusTitle}</IonText>
                                </IonCol>
                            </IonRow>
                            {loadingDonations && <>

                                {!donations || donations.length<1
                                    ? <p className="ion-padding">{siteText.historyNoTransactionsText}</p>
                                    : <DonationsList />
                                }
                            </>
                            }

                        </>
                    }
                    {view === 1 &&
                        <>
                            <IonRow className="documentInfoHeader ion-padding-start ion-padding-end ion-hide-sm-down" >
                                <IonCol sizeSm="3">
                                    <IonText>{siteText.historyDateTitle}</IonText>
                                </IonCol>
                                <IonCol sizeSm="2">
                                    <IonText>{siteText.historyAmountTitle}</IonText>
                                </IonCol>
                                <IonCol sizeSm="4">
                                    <IonText>{siteText.historyTransactionMethodTitle}</IonText>{/* */}
                                </IonCol>
                                <IonCol sizeSm="3">
                                    <IonText>{siteText.historyStatusTitle}</IonText>
                                </IonCol>
                            </IonRow>
                            {loadingCredits && 
                            <>
                            {!credits || credits.length<1
                                    ? <p className="ion-padding">{siteText.historyNoTransactionsText}</p>
                                    : <CreditList></CreditList>}
                            </>
                                
                            }
                        </>
                    }
                </IonGrid>
                <Footer></Footer>
            </IonContent>
        </IonPage>)
}

export default Profile;

